"use client";

import type { ComponentProps } from "react";
import { useController, useFormContext } from "react-hook-form";
import { Input } from "./Input";

export const InputField = ({ name, ...props }: ComponentProps<typeof Input> & { name: string }) => {
	const { control } = useFormContext();

	const {
		field,
		fieldState: { error },
	} = useController({
		name,
		control,
	});

	return <Input {...field} errorMessage={error?.message} isInvalid={!!error} {...props} />;
};
